<template>
  <div>
    <Loader cover v-if="local.isProcessing"/>
    <Filters :mode="mode"/>
    <ListTable/>
  </div>
</template>

<script>
  import {state} from './data';
  import {MODE_EDIT} from "@/utils/page-mode";

  export default {
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      Filters: () => import('./SubComponents/StudentEnrollFilters.vue'),
      ListTable: () => import('./SubComponents/StudentEnrollList.vue'),
    },
    data() {
      return {
        local: state.local,
        mode: MODE_EDIT,
      }
    },
  }
</script>
